"use client"

import posthog from "posthog-js"
import { PostHogProvider as PHProvider } from "posthog-js/react"

// PostHog is initialized in instrumentation-client.js (Next.js 15.3+ approach)

export function PostHogProvider({ children }) {
  return <PHProvider client={posthog}>{children}</PHProvider>
}
